import {
  infiniteflix,
  sessions,
  todoapp,
  ostrich,
  sunflower,
  medical,
  reshumon,
  weatherApp,
  panda,
  twitter,
} from './imports';
import {
  FaJsSquare,
  FaReact,
  FaNode,
  FaHtml5,
  FaCss3Alt,
  FaPaypal,
  FaYahoo,
  FaMdb,
} from 'react-icons/fa';
import {
  SiRedux,
  SiNextdotjs,
  SiTailwindcss,
  SiFirebase,
  SiTypescript,
} from 'react-icons/si';
const data = [
  {
    title: 'Twitter Clone',
    description: `
    Twitter Front page clone, with functional login, database using Sanity, Server-Side-Rendering, TailWindCss.
  `,
    demo: 'https://twitter-clone-ak4153.vercel.app/',
    source: 'https://github.com/ak4153/twitter-clone',
    img: twitter,
    icons: [
      <FaJsSquare />,
      <FaReact />,
      <FaHtml5 />,
      <FaCss3Alt />,
      <SiNextdotjs />,
      <SiTailwindcss />,
    ],
  },
  {
    title: 'Panda',
    description: `
  SPA for managing salary in the operating room setting.
  SEO friendly, packed with VITE for reduced loading time.
  `,
    demo: 'https://panda-55eba.web.app/',
    source: 'https://panda-55eba.web.app/',
    img: panda,
    icons: [
      <FaJsSquare />,
      <FaReact />,
      <FaHtml5 />,
      <FaCss3Alt />,
      <SiFirebase />,
      <SiTypescript />,
    ],
  },
  {
    title: 'Sharp App',
    description: `
    React single page weather application, with Autocomplete, dark-mode and celsius<->farenheit switches.
  `,
    demo: 'https://sharpapp4153.web.app/',
    source: 'https://github.com/ak4153/Alex-Kreizelman-31-03-2022',
    img: weatherApp,
    icons: [
      <FaJsSquare />,
      <FaReact />,
      <FaHtml5 />,
      <FaCss3Alt />,
      <SiRedux />,
    ],
  },
  // {
  //   title: 'Reshumon',
  //   description: `
  //   React single page application for Creating, Reading, Updating and Deleting entries of First name, Last Name and ID number.
  // `,
  //   demo: 'https://crudotest.herokuapp.com/',
  //   source: 'https://github.com/ak4153/ReshumonApp',
  //   img: reshumon,
  //   icons: [
  //     <FaJsSquare />,
  //     <FaNode />,
  //     <FaReact />,
  //     <FaHtml5 />,
  //     <FaCss3Alt />,
  //     <FaMdb />,
  //   ],
  // },
  // {
  //   title: 'Fluorescent',
  //   description: `
  //   The Hospital setting always reminds us of white lights.
  //   So here it is a Medical theme website for HR in the medical profession.

  // `,
  //   demo: 'https://medical-ak4153.vercel.app/',
  //   source: 'https://github.com/ak4153/medical',
  //   img: medical,
  //   icons: [<FaJsSquare />, <FaReact />, <FaHtml5 />, <FaCss3Alt />],
  // },
  {
    title: 'Sunflower',
    description: `
An e-commerce single page application for selling designer textile for dogs, includes Paypal integration and admin dashboard.
Developed with Next both back and frontend.
  `,
    demo: 'https://sun-flower.vercel.app/',
    source: 'https://github.com/ak4153/Sun-Flower',
    img: sunflower,
    icons: [
      <FaJsSquare />,
      <FaNode />,
      <FaReact />,
      <FaHtml5 />,
      <FaCss3Alt />,
      <FaMdb />,
      <FaPaypal />,
    ],
  },
  // {
  //   title: 'InfiniteFlix',
  //   description: `
  //   A minimalistic movie catalog, which lets you search movies
  //   both by title, IMDB rating and year or simply just scrolling
  //   beyond infinity.
  //   The backend fetches data from MongoDB IMDB database and includes pagination for improved performance.
  // `,
  //   demo: 'https://infiniteflix-e2c22.web.app/movies',
  //   source: 'https://github.com/ak4153/InfiniteFlix',
  //   img: infiniteflix,
  //   icons: [
  //     <FaJsSquare />,
  //     <FaNode />,
  //     <FaReact />,
  //     <FaHtml5 />,
  //     <FaCss3Alt />,
  //     <FaMdb />,
  //   ],
  // // },
  // {
  //   title: 'Salary Calculator',
  //   description: `
  //   An appropriate solution to a problem, means only one thing, making
  //   an application to solve it.
  //   An intuitive app for bookkeeping salary earned from
  //   Session operations in Israeli hospitals for the nursing sector.
  //   Built with Node.js, ejs and MongoDB cloud.
  // `,
  //   demo: 'https://vast-brushlands-31105.herokuapp.com/',
  //   source: 'https://github.com/ak4153/session-bookkeeper/tree/master',
  //   img: sessions,
  //   icons: [<FaJsSquare />, <FaNode />, <FaHtml5 />, <FaCss3Alt />, <FaMdb />],
  // },

  // {
  //   title: 'Ostrich - Market Viewer',
  //   description: `
  //   Stock market viewer using Yahoo finance api.
  //   Includes Google firebase authentication and authorization.
  // `,
  //   demo: 'https://ostrich4153.web.app/',
  //   source: 'https://github.com/ak4153/ostrich',
  //   img: ostrich,
  //   icons: [
  //     <FaJsSquare />,
  //     <FaYahoo />,
  //     <FaReact />,
  //     <FaHtml5 />,
  //     <FaCss3Alt />,
  //   ],
  // },
  // {
  //   title: 'Todo List',
  //   description: `
  //   One of the first MERN stack applications I have brought to light.
  //   Once I saw what React can achieve, I was mesmarised.
  // `,
  //   demo: 'https://naughty-rosalind-443ea7.netlify.app/',
  //   source: 'https://github.com/ak4153/MERN-stack-TodoApp',
  //   img: todoapp,
  //   icons: [
  //     <FaJsSquare />,
  //     <FaNode />,
  //     <FaReact />,
  //     <FaHtml5 />,
  //     <FaCss3Alt />,
  //     <FaMdb />,
  //   ],
  // },
];
export { data };
